import React from "react";
import { Box, Typography, Button } from "@mui/material";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", p: 4, textAlign: "center" }}>
          <Typography variant="h5" fontWeight={700} color="error" mb={2}>Something went wrong</Typography>
          <Typography color="text.secondary" mb={3} maxWidth={500}>
            {this.state.error?.message || "An unexpected error occurred on this page."}
          </Typography>
          <Button variant="contained" onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            sx={{ background: "linear-gradient(135deg,#4A7BA8,#244C77)" }}>
            Reload Page
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
